import React from 'react'

function MobileNav() {
  return (
    <ul>
    <li>
      <a href="#about">About</a>
    </li>
    <li>
      <a href="#experience">Experience</a>
    </li>
    <li>
      <a href="#work">Work</a>
    </li>
    <li>
      <a href="#contact">Contact</a>
    </li>
  </ul>
  )
}

export default MobileNav